import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withRoleAware } from '../auth/roleAware';

const TabButton = withRoleAware(({ onClick, active, children, disabled }) => (
  <div>
    <button
      onClick={onClick}
      type="button"
      className={classnames('c-nav-tab', { 'is-active': active })}
      disabled={disabled}
    >
      {children}
    </button>
  </div>
));

class Tabs extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.func])).isRequired,
    active: PropTypes.number,
  }

  static defaultProps = {
    active: 0,
  }

  state = {
    active: this.props.active,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ active: nextProps.active });
    }
  }

  setActive = index => () => {
    this.setState({ active: index });
  }

  renderTab = (item, index) => {
    if (!item) return null;
    const onClick = item.props.onTabClick(index) || this.setActive(index);
    return (
      <TabButton
        onClick={onClick}
        active={this.state.active === index}
        {...item.props}
      >
        {item.props.title}
      </TabButton>
    );
  }

  renderTabs() {
    const { TabBarAction } = this.props;
    return (
      <div className="c-tabs-scrollable">
        <div className="c-tabs-container u-position-relative" data-automation-id="tabs">
          {Children.map(this.props.children, this.renderTab)}
          <div className="u-position-absolute c-nav-action">
            { TabBarAction && <TabBarAction />}
          </div>
        </div>
      </div>
    );
  }

  renderActiveTab(active = this.state.active) {
    return this.props.children[active];
  }

  render() {
    return (
      <div>
        {this.renderTabs()}
        <div className="c-separator" />
        {this.renderActiveTab()}
      </div>
    );
  }
}

const Tab = ({ title, deny, allow, onTabClick, disabled, ...props }) => (
  <div {...props} />
);
Tab.propTypes = {
  title: PropTypes.string.isRequired,
  deny: PropTypes.number,
  allow: PropTypes.number,
  onTabClick: PropTypes.func,
  disabled: PropTypes.bool,
};
Tab.defaultProps = {
  deny: null,
  allow: null,
  onTabClick: null,
  disabled: false,
};
Tabs.Tab = Tab;

export default Tabs;
